export default __webpack_public_path__ + "static/media/53.05d88638.jpeg";